import ApproveView from '@views/Settings/VirtualColleague/AI/ApproveView.vue';
import { createRouter, createWebHistory } from 'vue-router';
import { inject } from 'vue';
import type { Client } from '@keyvue/one-api-client';
import authenticationRoutes from './authentication';
import contactRoutes from './contact';
import documentRoutes from './document';
import settingRoutes from './settings';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/approve/:reportId',
            name: 'approve',
            components: {
                default: ApproveView,
            },
            props: {
                default: true,
            },
        },
        {
            path: '/',
            name: 'root',
            components: {},
            beforeEnter: () => {
                window.location.href = `${import.meta.env.VITE_LEGACY_APP_HOST}`;
            },
        },
        ...authenticationRoutes,
        ...contactRoutes,
        ...documentRoutes,
        ...settingRoutes,
    ],
});

router.beforeResolve(async (to, from, next) => {
    const client = inject<Client>('client');

    if (!client) {
        throw new Error('Failed to find client in route guard, did you initialize the api plugin?');
    }

    if (to.meta.anonymous === true) {
        return next();
    }

    await client.session.loadSession();

    if (!client.session.isLoggedIn) {
        window.location.replace(`${import.meta.env.VITE_LEGACY_APP_HOST}/user/login?redirect=${encodeURIComponent(window.location.href)}`);
        return next(false);
    }

    return next();
});

export default router;
